
import { AutomatedMessage } from "@/components/cashback/message-utils/types";
import { DatabaseMessage } from "./types";

export const transformDatabaseMessage = (dbMessage: DatabaseMessage): AutomatedMessage => {
  const metrics: AutomatedMessage['metrics'] = {
    byChannel: {}
  };

  // Transform metrics from array to object format
  if (dbMessage.automated_message_metrics) {
    dbMessage.automated_message_metrics.forEach(metric => {
      if (metric.channel === 'email' || metric.channel === 'whatsapp' || metric.channel === 'sms') {
        metrics.byChannel[metric.channel] = {
          openRate: metric.open_rate,
          clickRate: metric.click_rate,
          conversionRate: metric.conversion_rate,
          sentCount: metric.sent_count,
        };
      }
    });
  }

  // Parse channels from JSON if it's a string, otherwise use as is
  let channels = [];
  try {
    channels = typeof dbMessage.channels === 'string' 
      ? JSON.parse(dbMessage.channels) 
      : dbMessage.channels || [];
  } catch (error) {
    console.error('Error parsing channels:', error);
    channels = [];
  }

  return {
    id: dbMessage.id,
    sendTime: dbMessage.send_time,
    message: dbMessage.message,
    channels: Array.isArray(channels) ? channels : [],
    isActive: dbMessage.is_active,
    smsTemplateId: dbMessage.sms_template_id,
    metrics
  };
};
